/* gr-wishlist.js — localStorage-backed wishlist.
 *
 * Storage: gr_wishlist = JSON array of product handles.
 * Events:
 *   - gr:wishlist-changed  → { handles: string[], added?: string, removed?: string }
 * API (window.GRWishlist):
 *   .list() -> string[]
 *   .has(handle) -> bool
 *   .add(handle)
 *   .remove(handle)
 *   .toggle(handle) -> 'added' | 'removed'
 *   .count() -> number
 *   .clear()
 *
 * Also hydrates any [data-gr-wishlist-badge] with count and any
 * [data-gr-wish-btn] buttons with the correct is-saved state.
 *
 * Cross-tab: listens to 'storage' event to stay in sync.
 */
(function () {
  'use strict';

  var KEY = 'gr_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (x) { return typeof x === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }

  function emit(detail) {
    document.dispatchEvent(new CustomEvent('gr:wishlist-changed', { detail: detail }));
    syncBadges();
    syncButtons();
  }

  var api = {
    list: function () { return read().slice(); },
    has: function (h) { return read().indexOf(h) !== -1; },
    count: function () { return read().length; },
    add: function (h) {
      if (!h) return;
      var arr = read();
      if (arr.indexOf(h) === -1) {
        arr.unshift(h);
        write(arr);
        emit({ handles: arr, added: h });
      }
    },
    remove: function (h) {
      var arr = read();
      var i = arr.indexOf(h);
      if (i !== -1) {
        arr.splice(i, 1);
        write(arr);
        emit({ handles: arr, removed: h });
      }
    },
    toggle: function (h) {
      if (this.has(h)) { this.remove(h); return 'removed'; }
      this.add(h); return 'added';
    },
    clear: function () {
      write([]);
      emit({ handles: [], cleared: true });
    }
  };

  function syncBadges() {
    var c = api.count();
    document.querySelectorAll('[data-gr-wishlist-badge]').forEach(function (el) {
      el.textContent = c;
      el.toggleAttribute('data-empty', c === 0);
    });
  }

  function syncButtons() {
    var set = new Set(read());
    document.querySelectorAll('[data-gr-wish-btn]').forEach(function (btn) {
      var h = btn.dataset.handle;
      var saved = set.has(h);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = btn.querySelector('[data-gr-wish-label]');
      if (label) label.textContent = saved ? 'Saved' : 'Save';
    });
  }

  // Delegate clicks on wishlist buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gr-wish-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var h = btn.dataset.handle;
    if (!h) return;
    var action = api.toggle(h);
    // Toast (lightweight)
    showToast(action === 'added' ? 'Saved to wishlist' : 'Removed from wishlist');
  });

  // Cross-tab sync
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { syncBadges(); syncButtons(); }
  });

  // Toast helper
  var toastEl;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gr-wish-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 1800);
  }

  // Init
  window.GRWishlist = api;
  document.addEventListener('DOMContentLoaded', function () {
    syncBadges();
    syncButtons();
  });
  // If DOM already ready
  if (document.readyState !== 'loading') { syncBadges(); syncButtons(); }
})();
